import { mixins } from "./StyledMixins";

export const query = {
  xxs: {
    minWidth: 0,
    maxWidth: 319,
  },
  xs: {
    minWidth: 320,
    maxWidth: 374,
  },
  sm: {
    minWidth: 375,
    maxWidth: 767,
  },
  md: {
    minWidth: 768,
    maxWidth: 1079,
  },
  lg: {
    minWidth: 1080,
    maxWidth: 1439,
  },
  xl: {
    minWidth: 1440,
    maxWidth: 1647,
  },
  xxl: {
    minWidth: 1648,
    maxWidth: 1799,
  },
  xxxl: {
    minWidth: 1800,
  },
};

export const isMobile = ["xxs", "xs", "sm"];

const figmaBase = {
  base: {
    color_freshred_100: "rgba(219,49,49,1)",
    color_black_25: "rgba(0,0,0,0.25)",
    color_black_50: "rgba(0,0,0,0.5)",
    color_black_60: "rgba(0,0,0,0.60)",
    color_black_65: "rgba(0,0,0,0.65)",
    color_black_100: "rgba(0,0,0,1)",
    color_offblack_10: "rgba(31,32,33,0.1)",
    color_offblack_25: "rgba(31,32,33,0.25)",
    color_offblack_50: "rgba(31,32,33,0.5)",
    color_offblack_100: "rgba(31,32,33,1)",
    color_offwhite_50: "rgba(221,221,221,0.5)",
    color_offwhite_20: "rgba(221,221,221,0.2)",
    color_offwhite_100: "rgba(221,221,221,1)",
    color_white_10: "rgba(255,255,255,0.1)",
    color_white_25: "rgba(255,255,255,0.25)",
    color_white_50: "rgba(255,255,255,0.5)",
    color_white_75: "rgba(255,255,255,0.75)",
    color_white_80: "rgba(255,255,255,0.80)",
    color_white_100: "rgba(255,255,255,1)",
    scale_0: 0,
    scale_px: 1,
    scale_0_25: 2,
    scale_0_50: 4,
    scale_0_75: 6,
    scale_1: 8,
    scale_1_25: 10,
    scale_1_375: 11,
    scale_1_50: 12,
    scale_1_75: 14,
    scale_2: 16,
    scale_2_25: 18,
    scale_2_50: 20,
    scale_2_75: 22,
    scale_3: 24,
    scale_3_25: 26,
    scale_3_50: 28,
    scale_3_75: 30,
    scale_4: 32,
    scale_4_50: 36,
    scale_5: 40,
    scale_6: 48,
    scale_7: 56,
    scale_7_50: 60,
    scale_8: 64,
    scale_9: 72,
    scale_10: 80,
    scale_11: 88,
    scale_12: 96,
    scale_13: 104,
    scale_14: 112,
    scale_15: 120,
    scale_16: 128,
    scale_17: 136,
    scale_18: 144,
    scale_19: 152,
    scale_20: 160,
    scale_21: 168,
    scale_22: 176,
    scale_23: 184,
    scale_24: 192,
    scale_25: 200,
    scale_26: 208,
    scale_27: 216,
    scale_28: 224,
    scale_29: 232,
    scale_30: 240,
    scale_40: 320,
    scale_50: 400,
    scale_60: 480,
    scale_70: 560,
    scale_80: 640,
    scale_90: 720,
    scale_100: 800,
    scale_200: 1600,
    fontfamily_mlstifo_standard: "MLSTifo",
    fontfamily_mlstifo_headline: "MLSTifoHeadline",
    fontfamily_mlstifo_micro: "MLSTifoMicro",
    fontweight_bold: "bold",
  },
};

const figmaCommon = {
  common: {
    color_time_light: figmaBase.color_black_65,
    color_time_dark: figmaBase.color_white_100,
    letterspacing_expanded: "2%",
    letterspacing_tight: "-2%",
  },
};

const figmaComponent = {
  component: {
    color_scorebug_bg_live: figmaBase.base.color_offblack_100,
    color_scorebug_divider_live: figmaBase.base.color_white_50,
    color_scorebug_bg_post_light: figmaBase.base.color_offblack_10,
    color_scorebug_divider_post_light: figmaBase.base.color_offblack_25,
    color_scorebug_bg_post_dark: figmaBase.base.color_white_10,
    color_scorebug_divider_post_dark: figmaBase.base.color_white_25,
    color_scorebug_score_dark: figmaBase.base.color_white_100,
    color_scorebug_score_light: figmaBase.base.color_off_black100,
    radius_scorebug_bg: figmaBase.base.scale_0_50,
    width_scorebug: figmaBase.base.scale_7_50,
    typography_scorebug_score: {
      fontFamily: figmaBase.base.fontfamily_mlstifo_standard,
      fontWeight: figmaBase.base.fontweight_bold,
      lineHeight: figmaBase.base.scale_1_75,
      fontSize: figmaBase.base.scale_2,
    },
  },
};

const figmaGlobal = {
  ...figmaBase,
  ...figmaCommon,
};

export const themeTypes = {
  light: "light",
  dark: "dark",
};

export const rgba = {
  white_100: "rgba(255, 255, 255, 1)",
  white_100_60: "rgba(255, 255, 255, 0.6)",
  white_111: "rgba(111, 111, 111, 1)",
  white_120: "rgba(120, 120, 120, 1)",
  white_240: "rgba(240, 240, 240, 1)",
  white_178: "rgba(178, 178, 178, 1)",
  white_238: "rgba(238, 238, 238, 1)",
  black_33_25: "rgba(33, 33, 33, .25)",
  black_33: "rgba(33, 33, 33, 1)",
  black_65: "rgba(65, 65, 65, 1)",
  black_45: "rgba(45, 45, 45, 1)",
  black_100: "rgba(0, 0, 0, 1)",
  black_33_1: "rgba(33, 33, 33, 0.1)",
  black_100_60: "rgba(0, 0, 0, 0.6)",
  black_100_40: "rgba(0, 0, 0, 0.4)",
  black_100_50: "rgba(0, 0, 0, 0.5)",
  violet_34_17_34: "rgba(34, 17, 34, 1)",
};

export const backgroundTypes = {
  white: "white",
  black: "black",
};

export const Theme = {
  type: themeTypes.light,
  rgba,
  figma: {
    ...figmaGlobal,
    ...figmaComponent,
  },
  mixins: { ...mixins },
  query,
};
